export const ONBOARDING_FLAG_KEY = 'player_onboarding_seen';
export const PLAYER_ONBOARDING_REOPEN_EVENT = 'player-onboarding:reopen';
